import React, { useMemo } from 'react';
import Carousel from 'react-elastic-carousel';
import { useFlatExperiences } from '@app/hooks';
import FlatExperienceItem from '@components/FlatExperiencesCarousel/components/FlatExperience';
import { Container, Title } from './styles';
import { useCarouselScrollLock } from '@app/hooks/useCarouselScrollLock';
import { useScreenSize } from '@app/hooks/useScreenSize';

export interface FlatExperiencesCarouselProps {
  outerSpacing?: number;
  flatExperiencesData: any;
}

const FlatExperiencesCarousel = ({
  outerSpacing,
  flatExperiencesData,
}: FlatExperiencesCarouselProps) => {
  const { flatExperiencesContent, groupId, flatExperiencesCarouselTitle } =
    useFlatExperiences({ flatExperiencesData });

  const { handleTouchMove, handleTouchStart } = useCarouselScrollLock();

  const screenWidth = useScreenSize();

  const itemsToShow = useMemo(() => {
    if (screenWidth < 645) return 1;
    if (screenWidth >= 645 && screenWidth < 1024) return 2;
    if (screenWidth >= 645) return 3;
  }, [screenWidth]);

  if ((flatExperiencesContent || []).length <= 0) return null;

  return (
    <Container>
      <Title>
        {flatExperiencesCarouselTitle
          ? flatExperiencesCarouselTitle
          : 'Supporting Content'}
      </Title>
      {/*
      // @ts-ignore */}
      <Carousel
        itemsToShow={itemsToShow}
        pagination={false}
        showArrows={false}
        itemPadding={[0, 6, 0, 6]}
        outerSpacing={outerSpacing ?? 16}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        style={{
          touchAction: 'pan-y', // Allows vertical scroll until explicitly prevented
        }}
      >
        {flatExperiencesContent?.map((flatExperience) => (
          <React.Fragment key={flatExperience?.slug}>
            <FlatExperienceItem
              props={flatExperience}
              groupId={groupId}
              isCarousel
            />
          </React.Fragment>
        ))}
      </Carousel>
    </Container>
  );
};

export default FlatExperiencesCarousel;
